module.exports = __webpack_public_path__ + "fonts/Lato-HeavyItalic.38d2399f.woff";